import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_SELECTIONS = 'SET_SELECTION';
export const RESET_SELECTIONS = 'RESET_SELECTION';
export const SET_SELECTED_ID = 'SET_SELECTED_ID';
export const RESET_SELECTED_ID = 'RESET_SELECTED_ID';

export const setSelections = makeActionCreator(SET_SELECTIONS);
export const resetSelections = makeActionCreator(RESET_SELECTIONS);
